import React from 'react'
import { useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import View from './View'
import BackArrowSvg from '../other/svg/BackArrowSvg'
import Space from './Space'
import { useNavigate } from 'react-router-dom'

interface Props {
  offer_hash_id: string
}

const BackToConversationList = ({ offer_hash_id }: Props): JSX.Element => {
  const conversationVehicleLabel = useSelector((state: RootReducer) => {
    const listConversation = state.conversationsListReducer.conversations.find(
      (item) => item.offer_hash_id === offer_hash_id
    )
    const label1 = listConversation?.label1
    const label2 = listConversation?.label2
    return `${label1?.toUpperCase() ?? ''} ${label2?.toUpperCase() ?? ''}`
  })
  const navigate = useNavigate()
  const labelStyles = 'flex justify-between items-center bg-groupBlue text-white h-14 px-8 rounded-[30px] w-[100%]'
  return (
    <>
      <Space y={2} />
      <View
        className="flex gap-2 items-center cursor-pointer"
        onClick={() => {
          navigate(-1)
        }}>
        <BackArrowSvg className="h-8 w-8 text-groupBluer" />
        <View className={labelStyles}>
          <span>{conversationVehicleLabel}</span>
          <span>{offer_hash_id.toUpperCase()}</span>
        </View>
      </View>
      <Space y={6} />
    </>
  )
}

export default BackToConversationList
